import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-354c6f76")

_pushScopeId("data-v-354c6f76")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "right-container flex-grow flex flex-col justify-between h-screen" }
const _hoisted_3 = { class: "flex-grow flex flex-col items-start bg-primary-100 overflow-y-scroll overflow-x-scroll px-12 pt-12" }
const _hoisted_4 = { class: "lg:flex flex-col mb-4 px-4 py-3 w-full bg-white rounded-md" }
const _hoisted_5 = { class: "flex flex-col justify-between gap-3" }
const _hoisted_6 = { class: "text-3xl font-bold" }
const _hoisted_7 = { class: "text-gray-500" }
const _hoisted_8 = { class: "panel-container rounded-md bg-white w-full pb-2 mb-16 lg:mb-8" }
const _hoisted_9 = { class: "relative z-10 items-center justify-between w-full table-header-color px-4 py-3" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-8"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "text-gray-500 text-sm" }, "情報取得中...", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_MqQuestionLogItem = _resolveComponent("MqQuestionLogItem")
  const _component_MLoadingIcon = _resolveComponent("MLoadingIcon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_MNavBar),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_MHeaderPanel, {
        title: "QANDA質問",
        breadcrumbs: _ctx.breadcrumbs
      }, null, 8, ["breadcrumbs"]),
      _createVNode("main", _hoisted_3, [
        _createVNode("section", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("p", _hoisted_6, _toDisplayString(`生徒名: ${_ctx.student ? _ctx.student.data.name : "取得中..."}`), 1),
            _createVNode("p", _hoisted_7, _toDisplayString(`Qanda ID: ${_ctx.student ? _ctx.student.data.qandaUserId : "取得中..."}`), 1)
          ])
        ]),
        _createVNode("section", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_MqQuestionLogItem, {
              messages: _ctx.messages,
              student: _ctx.student
            }, null, 8, ["messages", "student"])
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode(_component_MLoadingIcon),
                _hoisted_11
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
})